module.exports = __webpack_public_path__ + "static/media/Code2Shop-Logo-Contrast.a4078f66.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo/Code2Shop-Logo-Contrast.png
// module id = 1079
// module chunks = 0